import { Navigation, NavigationButton, NavigationOptions } from "./Navigation.js";

export interface MelodyNavigationOptions extends NavigationOptions {

}

export class MelodyNavigation extends Navigation {

    public readonly home: NavigationButton;
    public readonly help: NavigationButton;
    public readonly reset: NavigationButton;

    constructor(options: MelodyNavigationOptions) {
        super(options);

        this.home = this.addButton({
            icon: "icon-588",
            title: "Home"
        });

        // this.back = this.addButton({
        //     icon: "icon-590",
        //     title: "Back",
        //     visible: false
        // });

        this.reset = this.addButton({
            icon: "icon-589",
            title: "Restart",
            visible: false
        });

        this.help = this.addButton({
            icon: "icon-587",
            title: "Help",
            visible: false
        });
    }
}